import { render, staticRenderFns } from "./stockAssemblyItem.vue?vue&type=template&id=7b130128&"
import script from "./stockAssemblyItem.vue?vue&type=script&lang=js&"
export * from "./stockAssemblyItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports